import React, { useMemo } from 'react';
import Box from '@mui/material/Box';
import { safelyParseDate } from '@/utils/date';

export const getTransactions = (policies) => {
	const policyIds = Array.from(
		new Set((policies ?? []).map((r) => r?.policy?.Id).filter((p) => p != null)),
	);

	const transactions = policyIds.reduce((acc, id) => {
		const trans = policies
			.map((p) => p?.transaction)
			.filter((p) => p?.PolicyId === id)
			.map((t) => ({
				...t,
				date: t.PostedWhen ? safelyParseDate(t.PostedWhen) : null,
			}));
		// console.log('trans', trans);
		trans.sort((a, b) => b - a);
		acc[id] = {
			transactions: trans,
			policy: policies.find((p) => p?.policy?.Id === id),
		};
		return acc;
	}, {});

	return { policyIds, transactions };
};
export const getPolicyData = ({ policies }) => {
	const { policyIds, transactions } = getTransactions(policies);

	const checkPolicyInactive = (transaction) => {
		console.log('Transaction', transaction);
		if (!transaction) return true;
		return !transaction?.isCurrent || transaction?.IsLapsed;
	};

	return {
		policyIds,
		transactions,
		checkPolicyInactive,
	};
};

export const STACK_PROPS = {
	direction: 'column',
	spacing: 2,
	divider: <Box sx={{ height: '1px', backgroundColor: 'divider', width: '100%' }} />,
	sx: {
		justifyContent: 'space-around',
		alignItems: 'stretch',
		width: '100%',
		height: '100%',
	},
};
